<template>
  <v-style>
    body, .body-authentification-layout { background-color: white; }
  </v-style>
  <div
    class="body-authentification-layout text-center d-flex flex-column h-100"
  >
    <main class="form-authentification">
      <img class="mb-4" src="../assets/logo.png" alt="" height="57" />
      <slot />
    </main>
    <DefaultFooter />
  </div>
</template>
<script>
import { onMounted } from "@vue/runtime-core";
import DefaultFooter from "@/components/DefaultFooter.vue";

export default {
  components: { DefaultFooter },
  setup: () => {
    // mounted
    onMounted(() => {
      console.debug("Component is mounted!");
    });
  },
};
</script>

<style scoped>
.bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

.form-authentification .checkbox {
  font-weight: 400;
}

.form-authentification .form-floating:focus-within {
  z-index: 2;
}

.form-authentification input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.form-authentification input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>

<style>
.form-authentification {
  width: 100%;
  max-width: 373px;
  padding: 15px;
  margin: auto;
}
</style>
